import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addLikesTabToUserProfile() {
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    items.add('likes', m(LinkButton, {
      href: app.route('user.likes', {
        username: user?.slug()
      }),
      icon: "far fa-thumbs-up"
    }, app.translator.trans('flarum-likes.forum.user.likes_link')), 88);
  });
}